import { useNavigation } from 'expo-router';
import type { NavigationAction } from 'expo-router/react-navigation';
import { usePreventRemove } from 'expo-router/react-navigation';

const BACK_ACTION_TYPES = ['GO_BACK', 'POP', 'POP_TO_TOP'];

/**
 * Holds back navigation away from the current screen while `isPrevented` is
 * true: header back, swipe back, and Android back, including a back that
 * would dismiss the screen's whole stack. The held action is passed to
 * `onBack` so the caller can confirm or dispatch it later. Other navigation
 * (replace, reset, deep links) proceeds. Browser back on web cannot be
 * prevented.
 */
function usePreventBackNavigation(
  isPrevented: boolean,
  onBack: (action: NavigationAction) => void = () => null,
) {
  const navigation = useNavigation();

  usePreventRemove(isPrevented, ({ data }) => {
    if (BACK_ACTION_TYPES.includes(data.action.type)) {
      onBack(data.action);
    } else {
      // Without its own source key, dispatch stamps this screen's key, which an ancestor navigator cannot resolve.
      navigation.dispatch({ source: undefined, ...data.action });
    }
  });
}

export default usePreventBackNavigation;
